<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline">諸掛費用明細登録</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="
            !canCalFee ||
              !valid_adj ||
              !hasLocalFreight ||
              !ccFeeValid ||
              isPartnerSa ||
              customsNotFit ||
              isDoConfirmHanding
          "
          @click="save"
          v-permit.SHARP_LFL_SAVE
          >{{ $t('app.buttons.save') }}</v-btn
        >
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
        <v-btn
          :disabled="
            !canCalFee || !ccFeeValid || isPartnerSa || isDoConfirmHanding
          "
          @click="calculate2"
          v-permit.SHARP_LFL_SAVE
          >諸掛費用計算</v-btn
        >
        <!-- <v-btn :disabled="!canCalFee" @click="calculate2" v-permit.SHARP_LFL_SAVE>諸掛費用計算2</v-btn> -->
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form v-model="valid">
        <v-container fluid row>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field :value="sa.doNo" disabled label="D/O NO" />
            </v-flex>
            <v-flex v-if="!isWarehouseTransport" xs3>
              <remote-select
                :disabled="sa.hasAnyChildConfirmed"
                :rules="[(v) => !!v || ` 通関料区分 is required`]"
                clearable
                label="通関料区分"
                url="/customs-declaration-paper-types/kv"
                v-model="sa.customsDeclarationPaperTypeId"
              />
            </v-flex>
            <v-flex xs3>
              <v-select
                :disabled="true"
                :items="eiajItems"
                :rules="[(v) => !!v || ` 無償EIAJ発行 is required`]"
                clearable
                label="無償EIAJ発行"
                required
                v-model="sa.freeEiajIssue"
              />
            </v-flex>
            <v-flex xs3>
              <v-select
                :disabled="
                  sa.hasAnyChildConfirmed ||
                    sa.isAllPaid ||
                    sa.isAllUnpaid ||
                    sa.hasUnpaidDo
                "
                :items="freeItems"
                :rules="[(v) => !!v || ` 無償按分 is required`]"
                clearable
                item-text="text"
                item-value="value"
                label="無償按分"
                required
                v-model="sa.freeAllocation"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :value="shipment.doNo + '-' + shipment.branchCode"
                disabled
                label="D/O NO"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-btn @click="showDetail">P/L詳細</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                disabled
                url="ports/kv"
                v-model="shipment.loadingPortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                disabled
                url="ports/kv"
                v-model="shipment.dischargePortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-picker
                :label="$t('app.labels.etd')"
                disabled
                v-model="shipment.etd"
              ></date-picker>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-picker
                disabled
                label="ETA"
                v-model="shipment.eta"
              ></date-picker>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                disabled
                label="納入場所"
                url="warehouses/kv"
                v-model="shipment.finallyWarehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-picker
                disabled
                label="納入予定日付"
                v-model="shipment.forecastDeliveryDate"
              ></date-picker>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.bu.name')"
                disabled
                v-model="shipment.buInfo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="事業部"
                v-model="shipment.departmentInfo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-autocomplete
                :items="patterns"
                disabled
                item-text="name"
                item-value="code"
                label="配送パターン"
                v-model="shipment.deliveryPatternCode"
              ></v-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                disabled
                label="商品代金"
                v-model="shipment.subTotal"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <delivery-table
      :items="shipment.routes"
      :shipment="shipment"
      class="mt-2"
    ></delivery-table>
    <v-form v-model="valid_adj">
      <v-card class="mt-2">
        <v-card-title>
          <v-layout row wrap>
            <v-flex sm-4>請求費用詳細</v-flex>
            <v-flex sm-6 style="text-align: right; color: #c03"
              >請求・支払調整金額はマイナス金額入力のみで、かつ調整後金額は≧0</v-flex
            >
          </v-layout>
        </v-card-title>

        <v-card-text>
          <list-total-charges
            :canAdjust="canAdjust"
            :shipment="shipment"
            class="mt-2"
            :columns="chargeColumns"
            ignoreSupplier
            ref="requestArea"
          />
        </v-card-text>
      </v-card>
    </v-form>

    <!-- <v-card class="mt-2" v-if="shipment.transportModeCode=='AIR'">
      <v-card-title>
        <span>C.C.FEE</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="ccFee" v-model="ccFeeValid">
          <edit-charges
            :defaultDisabled="sa.hasAnyChildConfirmed"
            :shipment="shipment"
            :taxDate="shipment.forecastDeliveryDate"
            columns="0,19,15,16,20"
            scope="5"
          />
        </v-form>
      </v-card-text>
    </v-card>-->

    <v-card class="mt-2">
      <v-card-title>
        <span>追加支払請求費用</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="supplierValid">
          <edit-charges
            ref="additionalRequestAndPayment"
            :shipment="shipment"
            :taxDate="shipment.forecastDeliveryDate"
            :columns="additionRequestAndPaymentColumns"
            scope="1"
          />
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mt-2">
      <v-card-title>
        <span>追加請求</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="additionalRequestValid">
          <edit-charges
            ref="additionalRequest"
            :shipment="shipment"
            :taxDate="shipment.forecastDeliveryDate"
            :columns="additionRequestColumns"
            :columnHeaders="{ 22: '金額' }"
            scope="4"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <append-request-dialog :shipment="sa" ref="appendRequestDlg" />
    <b-l-detail ref="blDetail"></b-l-detail>
  </v-container>
</template>

<script>
import DeliveryTable from './DeliveryTable'
import AppendRequestDialog from './AppendRequestDialog'
import BLDetail from './BLDetail'
import { setTimeout } from 'timers'
export default {
  components: {
    DeliveryTable,
    AppendRequestDialog,
    BLDetail,
  },
  watch: {
    // 'sa.freeEiajIssue': function (val) {
    //   if (val === '発行する') {
    //     this.sa.freeAllocation = '按分する'
    //   } else if (val === '発行しない') {
    //     this.sa.freeAllocation = '按分しない'
    //   }
    // },
  },
  computed: {
    isDoConfirmHanding() {
      return this.shipment.doConfirmStatus === '0'
    },
    isDapDdp() {
      return (
        this.shipment.incotermId &&
        'INCOTERM-DAP,INCOTERM-DDP'.indexOf(this.shipment.incotermId) !== -1
      )
    },
    chargeColumns() {
      if (this.isDapDdp) {
        return '0,1,2,3,4,5,6,7,8,9,10,11,12'
      }
      return '0,1,2,3,4,5,6,7,8,9,10,11'
    },
    additionRequestAndPaymentColumns() {
      if (this.isDapDdp) {
        return '0,21,22,23,15,26,27,28,25,16,24'
      }
      return '0,21,22,23,15,26,16,8'
    },
    additionRequestColumns() {
      if (this.isDapDdp) {
        return '0,22,15,26,27,28,8,24'
      }
      return '0,22,15,8'
    },
    customsNotFit() {
      return (
        this.shipment.charges
          .filter((i) => i.chargeItemCode === 'LOCAL-007')
          .filter(
            (i) =>
              i.customsDeclarationPaperTypeId !==
              this.sa.customsDeclarationPaperTypeId
          ).length > 0
      )
    },
    unpaidShipment() {
      return (
        this.shipment.packages &&
        this.shipment.packages.filter((pkg) => pkg.poId !== null).length === 0
      )
    },
    paidShipment() {
      return (
        this.shipment.packages &&
        this.shipment.packages.filter((pkg) => pkg.poId === null).length === 0
      )
    },
    isPartnerSa() {
      return this.shipment.saPartnerSa
    },
    hasLocalFreight() {
      return (
        this.shipment.charges.filter(
          (i) =>
            i.chargeItemScreenStatistics === '国内運賃' ||
            i.chargeItemScreenStatistics == 'destination charge'
        ).length > 0
        // &&
        // this.shipment.charges.filter(
        //   (i) => i.chargeItemScreenStatistics === 'そのた諸掛費用'
        // ).length > 0
      )
    },
    isWarehouseTransport() {
      return (
        ((this.shipment.transportModeId &&
          this.shipment.transportModeId.indexOf('-AIR') !== -1) ||
          (this.shipment.stackTypeId &&
            this.shipment.stackTypeId.indexOf('-FCL') !== -1)) &&
        this.shipment.isAllUnpaid &&
        this.shipment.specialId &&
        this.shipment.specialId.indexOf('WAREHOUSE_TRANSPORT') !== -1
      )
    },
    canCalFee() {
      return (
        ('DO業者確認済,DO諸掛登録済'.indexOf(this.shipment.status) !== -1 ||
          (this.isWarehouseTransport && this.shipment.status === 'DO解除済')) &&
        this.valid &&
        this.supplierValid &&
        this.additionalRequestValid
      )
    },
    containerQty() {
      return (
        this.shipment &&
        this.shipment.packages &&
        [...new Set(this.shipment.packages.map((p) => p.containerNo))].length
      )
    },
    invoiceAmount() {
      return (
        this.shipment &&
        this.shipment.packages &&
        this.shipment.packages.reduce((t, p) => {
          return t + p.jpytotal
        }, 0)
      )
    },
    bus() {
      return (
        this.shipment &&
        this.shipment.packages &&
        [
          ...new Set(this.shipment.packages.map((p) => p.buHeadquartersName)),
        ].join(', ')
      )
    },
    departments() {
      return (
        this.shipment &&
        this.shipment.packages &&
        [...new Set(this.shipment.packages.map((p) => p.departmentName))].join(
          ', '
        )
      )
    },
  },
  methods: {
    showDetail() {
      this.$refs.blDetail.popup(this.$route.query.id)
    },

    canAdjust(charge) {
      if (charge.isFreight || charge.isDestinationCharge) {
        return false
      }
      if (!this.sa.hasAnyChildConfirmed) {
        return charge.adjustable
      }
      return charge.adjustable && !charge.isChargeInSA
    },
    saveAdjustValue() {
      var value = this.shipment.charges
        .filter((i) => !i.isFreight && !i.isDestinationCharge)
        .filter((i) => i.adjustable == true)
        .map((c) => {
          return {
            // id: c.id,
            shipmentId: c.shipmentId,
            chargeItemId: c.chargeItemId,
            containerTypeCode: c.containerTypeCode,
            subTotalAdjust: c.subTotalAdjust,
            paymentSubTotalAdjust: c.paymentSubTotalAdjust,
            comment: c.comment,
          }
        })
      return this.$http.put(
        '/delivery-orders/adjust-value?token=subTotalAdjust',
        value
      )
    },
    catch(res) {
      if (res.response.status === 500) {
        if (res.response.data.message == 'DO_HAS_CONFIRMED') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.doConfirmed')
          )
        } else if (res.response.data.message == 'BL_NO_DUPLICATE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.blNoDuplicate')
          )
        } else if (res.response.data.message == 'EXCHANGE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.exchangeRateNotFound')
          )
        } else if (
          res.response.data.message.indexOf('PRICING_NOT_FOUND') !== -1
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.pricingNotFound', {
              chargeItem: res.response.data.message.split(';')[1],
            })
          )
        } else if (res.response.data.message == 'INSURANCE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.insuranceRateNotFound')
          )
        } else if (res.response.data.message == 'TAX_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.taxRateNotFound')
          )
        } else if (res.response.data.message == 'COMMISSION_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.commissionRateNotFound')
          )
        } else if (res.response.data.message == 'DEVAN_PRICING_REPEAT') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.devanPricingRepeat')
          )
        } else if (res.response.data.message == 'CURRENCY_CODE_NOT_EXISTS') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '通貨が存在していませんので、保存できません。'
          )
        } else if (res.response.data.message == 'ALL_UNPAID_WITH_ISSUE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '通貨が存在していませんので、保存できません。'
          )
        } else {
          this.$showError(res)
        }
      }
    },
    checkCurrency() {
      return this.$http.get(
        `/delivery-orders/${this.shipment.id}/check-currency`
      )
    },
    calculate2() {
      this.$http
        .put(
          `/shipping-advices/${this.sa.id}?view=B0802&token=ccfeeauto&version=${
            this.sa.version
          }`,
          this.sa
        )
        .then(() => {
          return this.$http.put(
            `/delivery-orders/${this.shipment.id}?view=B0802Calc`,
            this.shipment
          )
        })
        // .then(() => {
        //   return this.ccfeeUpdate()
        // })
        .then(() => {
          return this.$http.put(`/shipping-advices/${this.shipment.id}/calc`)
        })
        .then(() => this.saveAdjustValue())
        .then(() => {
          return this.checkCurrency()
        })
        .then(() => {
          return this.$http.put(`/shipping-advices/${this.sa.id}/charges-share`)
        })
        .then(() => this.putProviders())
        .then(() => {
          this.$message('', '諸掛費用計算成功')
          this.load()
        })
        .catch((res) => {
          this.catch(res)
        })
    },

    putProviders() {
      const currentShipmentId = this.shipment.id
      return this.$http.put(
        `/overseas-providers?shipmentId=${this.shipment.id}`,
        [
          ...this.$refs.requestArea
            .getCharges()
            .filter((i) => !i.isFreight)
            .map((i) => {
              return {
                shipmentId: i.shipmentId,
                chargeItemId: i.chargeItemId,
                providerId: i.providerId,
                containerTypeCode: i.containerTypeCode,
              }
            }),
          ...this.$refs.additionalRequestAndPayment.items.map((i) => {
            return {
              shipmentId: currentShipmentId,
              chargeItemId: i.id,
              providerId: i.providerId,
            }
          }),
          ...this.$refs.additionalRequest.items.map((i) => {
            return {
              shipmentId: currentShipmentId,
              chargeItemId: i.id,
              providerId: i.providerId,
            }
          }),
        ]
      )
    },

    // ccfeeUpdate() {
    //   return this.$http.put(`/shipping-advices/${this.sa.id}/ccfee-update`, {
    //     ...this.shipment.charges.filter(
    //       i => i.chargeItemCode == 'LOCAL-006'
    //     )[0],
    //     shipmentId: this.sa.id
    //   })
    // },
    save() {
      Promise.all([
        this.$http.put(
          `/shipping-advices/${this.sa.id}?view=B0802&token=ccfeeauto&version=${
            this.sa.version
          }`,
          this.sa
        ),
        this.$http.put(`/delivery-orders/domestic/${this.shipment.id}`, {
          ...this.shipment,
          status: 'DO諸掛登録済',
        }),
        // this.ccfeeUpdate()
      ])
        .then(() => this.saveAdjustValue())
        .then(() => this.checkCurrency())
        .then(() => this.putProviders())
        .then(() => {
          this.$router.push({
            path: '/B0800',
          })
        })
        .catch((err) => {
          this.$catch(err)
        })
    },
    getFilterSummaryCharges(loadData) {
      var ingored = ['商品代金', 'SJL Commission', '保険費']
      return loadData.summaryCharges.filter(
        (c) => ingored.indexOf(c.chargeItemScreenStatistics) == -1
      )
    },
    setInitialFreeIssue() {},
    getInitialFreeEiajIssue() {
      return '発行しない'
    },
    getInitialFreeAllocation(data) {
      // this.sa.isAllPaid 按分しない
      // this.sa.hasUnpaidDo 按分する
      // this.sa.isAllUnpaid 按分する
      console.log(data)
      if (data.freeAllocation) {
        console.log(data.freeAllocation)
        return data.freeAllocation
      }
      if (data.hasUnpaidDo) {
        console.log('按分する')
        return '按分する'
      }
      console.log('按分しない')
      return '按分しない'
    },
    load() {
      return this.$http
        .get(`delivery-orders/do/${this.$route.query.id}`)
        .then((res) => {
          this.shipment = {
            ...res.data,
            summaryCharges: this.getFilterSummaryCharges(res.data),
          }
          return this.shipment
        })
        .then((shipment) => {
          this.$http
            .get(`/shipping-advices/${shipment.doShipmentId}?view=B0802`)
            .then((res) => {
              this.sa = {
                ...res.data,
                freeEiajIssue: this.getInitialFreeEiajIssue(),
                freeAllocation: this.getInitialFreeAllocation(res.data),
              }
            })
        })
    },
    back() {
      this.$router.go(-1)
    },
    loadPatterns() {
      return this.$http.get('/patterns/all').then((res) => {
        this.patterns = res.data
      })
    },
  },
  mounted() {
    this.load().then(() => {
      setTimeout(() => {
        this.$refs.ccFee ? this.$refs.ccFee.validate() : null
      }, 100)
    })
    this.loadPatterns()
  },
  data() {
    return {
      errors: {
        SHIPMENT_HAS_CHANGED:
          '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
      },
      ccFeeValid: true,
      supplierValid: false,
      additionalRequestValid: false,
      valid: false,
      valid_adj: false,
      shipment: {},
      sa: {},
      deliveryItems: [],
      patterns: [],
      query: {},
      eiajItems: ['発行する', '発行しない'],
      freeItems: [
        {
          text: '無償按分する（無償純無償請求書する）',
          value: '按分する',
        },
        {
          text: '無償按分しない（無償純無償請求書しない）',
          value: '按分しない',
        },
      ],
      detailHeaders: [
        {
          label: 'D/O NO',
          field: 'deliveryOrderNo',
          sortable: false,
        },
        {
          label: '積出港',
          field: 'shippingPort',
          sortable: false,
        },
        {
          label: '陸揚港',
          field: 'landingPort',
          sortable: false,
        },
        {
          label: 'ETD',
          field: 'etd',
          sortable: false,
        },
        {
          label: 'ETA',
          field: 'eta',
          sortable: false,
        },
        {
          label: '納入場所',
          field: 'deliveryPlace',
          sortable: false,
        },
        {
          label: '納入予定日付',
          field: 'deliveryScheduleDate',
          sortable: false,
        },
        {
          label: '事業本部',
          field: 'businessHeadquarters',
          sortable: false,
        },
        {
          label: '事業部',
          field: 'division',
          sortable: false,
        },
        {
          label: '配送パターン',
          field: 'deliveryPattern',
          sortable: false,
        },
        {
          label: 'INV 外貨額',
          field: 'invForeignCurrencyAmount',
          sortable: false,
        },
        {
          label: 'コンテナ本数',
          field: 'containerNumbers',
          sortable: false,
        },
      ],
      dialogForm: {},
      billCostItems: [
        {
          expenseItem: '海上運賃',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
        {
          expenseItem: 'アジショナルチャージ',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
        {
          expenseItem: 'C.CFEE',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
        {
          expenseItem: '搬出手数料',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
        {
          expenseItem: '国内運賃',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
        {
          expenseItem: '取扱料',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
        {
          expenseItem: 'その他諸掛',
          amount: '',
          currency: '',
          let: '',
          convertedAmount: '',
        },
      ],
      additionCostItems: [
        {
          expenseItem: '追加費用（課税）1',
          amount: '',
          paymentDestination: '',
          comment: '',
        },
        {
          expenseItem: '追加費用（課税）2',
          amount: '',
          paymentDestination: '',
          comment: '',
        },
        {
          expenseItem: '追加費用（課税）３',
          amount: '',
          paymentDestination: '',
          comment: '',
        },
        {
          expenseItem: '追加費用（免税）１',
          amount: '',
          paymentDestination: '',
          comment: '',
        },
        {
          expenseItem: '追加費用（免税）２',
          amount: '',
          paymentDestination: '',
          comment: '',
        },
        {
          expenseItem: '追加費用（免税）３',
          amount: '',
          paymentDestination: '',
          comment: '',
        },
      ],
      form: [
        {
          label: 'B/L NO',
          field: 'bLNo',
          type: 'text',
          required: true,
        },
        {
          label: '海外取引先',
          field: 'overseasPartners',
          type: 'text',
          required: true,
        },
        {
          label: 'B/L発行日',
          field: 'blIssueDate',
          type: 'date',
          required: true,
        },
        {
          label: '輸送形態',
          field: 'transportForm',
          type: 'select',
          required: true,
        },
        {
          label: '積出港',
          field: 'shippingPort',
          type: 'autocomplete',
          required: true,
        },
        {
          label: '陸揚港',
          field: 'landingPort',
          type: 'autocomplete',
          required: true,
        },
        {
          label: 'ETD',
          field: 'etd',
          type: 'date',
          required: true,
        },
        {
          label: 'ETA',
          field: 'eta',
          type: 'date',
          required: true,
        },
        {
          label: '本船名',
          field: 'shipName',
          type: 'text',
        },
        {
          label: 'サプライヤー',
          field: 'supplier',
          type: 'autocomplete',
          required: true,
        },
        {
          label: '区分',
          field: 'classfication',
          type: 'select',
          required: true,
        },
      ],
    }
  },
}
</script>
